module.exports = __webpack_public_path__ + "static/media/22.2a6ed7bc.png";